export default {
    sales_deal_sent_ms: 1,
    sales_deal_paused: 2,
    sales_deal_sent_ot: 3,
    ms_deal_sent_ms: 4
}